import { render, staticRenderFns } from "./CopyUsersFromSubgroup.vue?vue&type=template&id=0d4f448f"
import script from "./CopyUsersFromSubgroup.vue?vue&type=script&lang=js"
export * from "./CopyUsersFromSubgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports